import { useMemo } from 'react';

import {
  BoardCrop, BoardSoil, BoardStatus, 
} from 'features/Croptimizer/types';
import { d23profit } from 'features/Croptimizer/utils/calcHelperBoard';
import { unMaskInput } from 'utils/helpers';

interface Props {
  boardStatusValues: BoardStatus | null;
  boardCropValues: BoardCrop | null;
  getY1CurrentProfit?: string | number;
  getY2CurrentProfit?: string | number;
  getY3CurrentProfit?: string | number;
  getY4CurrentProfit?: string | number;
  getY5CurrentProfit?: string | number;
  getY1CurrentLoss: string;
  getY2CurrentLoss: string;
  getY3CurrentLoss: string;
  getY4CurrentLoss: string;
  getY5CurrentLoss: string;
  boardSoilValues: BoardSoil | null;
}

const useYieldProfit = ({
  boardStatusValues,
  boardCropValues,
  getY1CurrentProfit,
  getY2CurrentProfit,
  getY3CurrentProfit,
  getY4CurrentProfit,
  getY5CurrentProfit,
  getY1CurrentLoss,
  getY2CurrentLoss,
  getY3CurrentLoss,
  getY4CurrentLoss,
  getY5CurrentLoss,
  boardSoilValues,
}: Props) => {
  const getY1YieldProfit = useMemo(() => {
    if (boardStatusValues && boardCropValues && boardSoilValues) {
      const v23 = d23profit(
        Number(boardCropValues?.cropGroupYield),
        Number(getY1CurrentLoss),
        Number(getY1CurrentProfit),
      );
      const v21 = Number(unMaskInput(boardCropValues?.currentYield));
      const v24 = v23 && v21 * Number(v23.toFixed(6));
      const v25 = v24 && v24 * Number(unMaskInput(boardCropValues?.price));

      if (
        Number(boardStatusValues?.currentPh) <
        Number(boardStatusValues?.targetPh)
      ) {
        return Math.round(v25 ? v25 : 0);
      } else {
        const getPercent = () => {
          if (Number(boardSoilValues?.split) === 2) {
            return 10;
          }

          if (Number(boardSoilValues?.split) === 3) {
            return 20;
          }

          if (Number(boardSoilValues?.split) === 4) {
            return 30;
          }

          if (Number(boardSoilValues?.split) === 5) {
            return 35;
          }

          return 0;
        };
        const penalty = (100 - getPercent()) / 100;

        return Math.round(v25 ? v25 * penalty : 0);
      }
    }

    return '';
  }, [
    boardStatusValues,
    boardCropValues,
    getY1CurrentProfit,
    getY1CurrentLoss,
  ]);

  const getY2YieldProfit = useMemo(() => {
    if (boardStatusValues && boardCropValues && boardSoilValues) {
      const v23 = d23profit(
        Number(boardCropValues?.cropGroupYield),
        Number(getY2CurrentLoss),
        Number(getY2CurrentProfit),
      );
      const v21 = Number(unMaskInput(boardCropValues?.currentYield));
      const v24 = v23 && v21 * Number(v23.toFixed(6));
      const v25 = v24 && v24 * Number(unMaskInput(boardCropValues?.price));

      if (
        Number(boardStatusValues?.currentPh) <
        Number(boardStatusValues?.targetPh)
      ) {
        return Math.round(v25 ? v25 : 0);
      } else {
        const getPercent = () => {
          if (Number(boardSoilValues?.split) === 2) {
            return 10;
          }

          if (Number(boardSoilValues?.split) === 3) {
            return 20;
          }

          if (Number(boardSoilValues?.split) === 4) {
            return 30;
          }

          if (Number(boardSoilValues?.split) === 5) {
            return 35;
          }

          return 0;
        };
        const penalty = (100 - getPercent()) / 100;

        return Math.round(v25 ? v25 * penalty : 0);
      }
    }

    return '';
  }, [
    boardStatusValues,
    boardCropValues,
    getY2CurrentLoss,
    getY2CurrentProfit,
  ]);

  const getY3YieldProfit = useMemo(() => {
    if (boardStatusValues && boardCropValues && boardSoilValues) {
      const v23 = d23profit(
        Number(boardCropValues?.cropGroupYield),
        Number(getY3CurrentLoss),
        Number(getY3CurrentProfit),
      );
      const v21 = Number(unMaskInput(boardCropValues?.currentYield));
      const v24 = v23 && v21 * Number(v23.toFixed(6));
      const v25 = v24 && v24 * Number(unMaskInput(boardCropValues?.price));

      if (
        Number(boardStatusValues?.currentPh) <
        Number(boardStatusValues?.targetPh)
      ) {
        return Math.round(v25 ? v25 : 0);
      } else {
        const getPercent = () => {
          if (Number(boardSoilValues?.split) === 2) {
            return 10;
          }

          if (Number(boardSoilValues?.split) === 3) {
            return 20;
          }

          if (Number(boardSoilValues?.split) === 4) {
            return 30;
          }

          if (Number(boardSoilValues?.split) === 5) {
            return 35;
          }

          return 0;
        };
        const penalty = (100 - getPercent()) / 100;

        return Math.round(v25 ? v25 * penalty : 0);
      }
    }

    return '';
  }, [
    boardStatusValues,
    boardCropValues,
    getY3CurrentLoss,
    getY3CurrentProfit,
  ]);

  const getY4YieldProfit = useMemo(() => {
    if (boardStatusValues && boardCropValues && boardSoilValues) {
      const v23 = d23profit(
        Number(boardCropValues?.cropGroupYield),
        Number(getY4CurrentLoss),
        Number(getY4CurrentProfit),
      );
      const v21 = Number(unMaskInput(boardCropValues?.currentYield));
      const v24 = v23 && v21 * Number(v23.toFixed(6));
      const v25 = v24 && v24 * Number(unMaskInput(boardCropValues?.price));

      if (
        Number(boardStatusValues?.currentPh) <
        Number(boardStatusValues?.targetPh)
      ) {
        return Math.round(v25 ? v25 : 0);
      } else {
        const getPercent = () => {
          if (Number(boardSoilValues?.split) === 2) {
            return 10;
          }

          if (Number(boardSoilValues?.split) === 3) {
            return 20;
          }

          if (Number(boardSoilValues?.split) === 4) {
            return 30;
          }

          if (Number(boardSoilValues?.split) === 5) {
            return 35;
          }

          return 0;
        };
        const penalty = (100 - getPercent()) / 100;

        return Math.round(v25 ? v25 * penalty : 0);
      }
    }

    return '';
  }, [
    boardStatusValues,
    boardCropValues,
    getY4CurrentLoss,
    getY4CurrentProfit,
  ]);

  const getY5YieldProfit = useMemo(() => {
    if (boardStatusValues && boardCropValues && boardSoilValues) {
      const v23 = d23profit(
        Number(boardCropValues?.cropGroupYield),
        Number(getY5CurrentLoss),
        Number(getY5CurrentProfit),
      );
      const v21 = Number(unMaskInput(boardCropValues?.currentYield));
      const v24 = v23 && v21 * Number(v23.toFixed(6));
      const v25 = v24 && v24 * Number(unMaskInput(boardCropValues?.price));

      if (
        Number(boardStatusValues?.currentPh) <
        Number(boardStatusValues?.targetPh)
      ) {
        return Math.round(v25 ? v25 : 0);
      } else {
        const getPercent = () => {
          if (Number(boardSoilValues?.split) === 2) {
            return 10;
          }

          if (Number(boardSoilValues?.split) === 3) {
            return 20;
          }

          if (Number(boardSoilValues?.split) === 4) {
            return 30;
          }

          if (Number(boardSoilValues?.split) === 5) {
            return 35;
          }

          return 0;
        };
        const penalty = (100 - getPercent()) / 100;

        return Math.round(v25 ? v25 * penalty : 0);
      }
    }

    return '';
  }, [
    boardStatusValues,
    boardCropValues,
    getY5CurrentLoss,
    getY5CurrentProfit,
  ]);

  const getTotalYieldProfit = useMemo(
    () => Number(getY1YieldProfit) +
      Number(getY2YieldProfit) +
      Number(getY3YieldProfit) +
      Number(getY4YieldProfit) +
      Number(getY5YieldProfit),
    [
      getY1YieldProfit,
      getY2YieldProfit,
      getY3YieldProfit,
      getY4YieldProfit,
      getY5YieldProfit,
    ],
  );

  return {
    getY1YieldProfit,
    getY2YieldProfit,
    getY3YieldProfit,
    getY4YieldProfit,
    getY5YieldProfit,
    getTotalYieldProfit,
  };
};

export default useYieldProfit;
